export const failoverReports = (builder) => ({
    failoverReports: builder.mutation({
        query: ({ page,
            limit,
            search,
            fallbackChannel,
            status,
            startDate,
            endDate },) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/failoverReports',
                method: 'GET',
                params: { page,
                    limit,
                    search,
                    fallbackChannel,
                    status,
                    startDate,
                    endDate },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});